import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';
import Theme from '../../theme';
import Anchor from '../Anchor';
import Column from '../Column';
import Grid from '../Grid';
import Row from '../Row';
import Avatar from './Avatar';
import Logo from './Logo';
import ShoppingCart from './ShoppingCart';
import IconLogin from '../../assets/svgs/header/mobile-login.svg';
import IconHamburger from '../../assets/svgs/hamburger-line.svg';
import VeriSignLogo from './VeriSignLogo';
var SCHeaderMobile = styled.div.withConfig({
  displayName: "MobileHeader__SCHeaderMobile",
  componentId: "sc-16gctj1-0"
})(["width:100%;", ";"], Theme.media.lg(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    display: none;\n  "]))));
var SCHamburger = styled.div.withConfig({
  displayName: "MobileHeader__SCHamburger",
  componentId: "sc-16gctj1-1"
})(["width:", ";cursor:pointer;"], remCalc(16));
var SCRightHandColumn = styled.div.withConfig({
  displayName: "MobileHeader__SCRightHandColumn",
  componentId: "sc-16gctj1-2"
})(["display:flex;align-items:center;float:right;"]);
var SCLogin = styled(Anchor).withConfig({
  displayName: "MobileHeader__SCLogin",
  componentId: "sc-16gctj1-3"
})(["margin-left:", ";"], remCalc(16));
var SCIconLogin = styled(IconLogin).withConfig({
  displayName: "MobileHeader__SCIconLogin",
  componentId: "sc-16gctj1-4"
})(["vertical-align:middle;"]);
var SCAvatar = styled.div.withConfig({
  displayName: "MobileHeader__SCAvatar",
  componentId: "sc-16gctj1-5"
})(["margin-left:", ";"], remCalc(16));
var SCShoppingCart = styled.div.withConfig({
  displayName: "MobileHeader__SCShoppingCart",
  componentId: "sc-16gctj1-6"
})(["margin-left:", ";"], remCalc(16));
var SCIconHamburger = styled(IconHamburger).withConfig({
  displayName: "MobileHeader__SCIconHamburger",
  componentId: "sc-16gctj1-7"
})(["vertical-align:middle;"]);

var HamburgerMenu = function HamburgerMenu(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(SCHamburger, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(SCIconHamburger, {
    size: 22
  }));
};

var MobileHeader = function MobileHeader(_ref2) {
  var baseUrl = _ref2.baseUrl,
      showHamburger = _ref2.showHamburger,
      logoLink = _ref2.logoLink,
      logoAlt = _ref2.logoAlt,
      onHamburgerClick = _ref2.onHamburgerClick,
      shoppingCartUrl = _ref2.shoppingCartUrl,
      loginUrl = _ref2.loginUrl,
      showVeriSignLogo = _ref2.showVeriSignLogo,
      showLoginButton = _ref2.showLoginButton,
      showShoppingCart = _ref2.showShoppingCart,
      showAvatar = _ref2.showAvatar,
      avatarMenuItems = _ref2.avatarMenuItems;
  return /*#__PURE__*/React.createElement(SCHeaderMobile, null, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Row, {
    middle: "sm"
  }, /*#__PURE__*/React.createElement(Column, null, showHamburger && /*#__PURE__*/React.createElement(HamburgerMenu, {
    onClick: onHamburgerClick
  })), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Logo, {
    baseUrl: baseUrl,
    link: logoLink,
    alt: logoAlt,
    padded: true
  })), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(SCRightHandColumn, null, showLoginButton && /*#__PURE__*/React.createElement(SCLogin, {
    href: "" + baseUrl + loginUrl,
    ariaLabel: "Login Button"
  }, /*#__PURE__*/React.createElement(SCIconLogin, {
    width: 24,
    height: 24
  })), showAvatar && /*#__PURE__*/React.createElement(SCAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
    baseUrl: baseUrl,
    menu: avatarMenuItems
  })), showShoppingCart && /*#__PURE__*/React.createElement(SCShoppingCart, null, /*#__PURE__*/React.createElement(ShoppingCart, {
    baseUrl: baseUrl,
    url: shoppingCartUrl
  })), showVeriSignLogo && /*#__PURE__*/React.createElement(VeriSignLogo, null))))));
};

export default MobileHeader;